import { useQuery } from "react-query";
import useNetworkHeaders from "../../hooks/useNetworkHeaders";
import { getCrmLookUpOptions, GetLookUpOptionsParamsType } from "../queries/getCrmLookUpOptions";

export default function useCrmLookUpOptions(params: GetLookUpOptionsParamsType, enabled: boolean) {
  const headers = useNetworkHeaders();
  const { isLoading, data } = useQuery(["CrmLookUpOptions", params], getCrmLookUpOptions(headers, params), { enabled });

  return {
    isLoading,
    data,
  };
}
